/**
 * CLEARO offer countdown — <clearo-countdown data-end="<unix seconds>">
 * Ticks every second. Last 48 hours: .is-urgent (red). Last 24 hours:
 * .is-last-day and the "Last day!" label. When the end time passes it hides
 * the offer blocks on the page ([data-clr-offer]) so nobody sees an expired deal.
 * Markup: snippets/clearo-countdown.liquid
 */
(() => {
  if (customElements.get('clearo-countdown')) return;

  const pad = (n) => String(n).padStart(2, '0');

  class ClearoCountdown extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end, 10) * 1000;
      if (!Number.isFinite(this.end)) return;
      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach((el) => (this.nums[el.dataset.unit] = el));
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (left === 0) {
        clearInterval(this.timer);
        document.querySelectorAll('[data-clr-offer]').forEach((el) => (el.hidden = true));
        this.hidden = true;
        return;
      }
      this.classList.toggle('is-urgent', left < 48 * 3600);
      const lastDay = left < 24 * 3600;
      if (lastDay !== this.classList.contains('is-last-day')) {
        this.classList.toggle('is-last-day', lastDay);
        const label = this.querySelector('[data-count-label]');
        if (label) {
          this.defaultLabel = this.defaultLabel || label.textContent;
          label.textContent = lastDay ? this.dataset.lastLabel || this.defaultLabel : this.defaultLabel;
        }
      }
      const parts = {
        d: Math.floor(left / 86400),
        h: Math.floor((left % 86400) / 3600),
        m: Math.floor((left % 3600) / 60),
        s: left % 60,
      };
      for (const [k, v] of Object.entries(parts)) {
        const el = this.nums[k];
        const text = k === 'd' ? String(v) : pad(v);
        if (el && el.textContent !== text) el.textContent = text;
      }
    }
  }

  customElements.define('clearo-countdown', ClearoCountdown);
})();
